import { createLucideIcon } from "lucide-react";

export const Menu2 = createLucideIcon(
    "Menu2",
    [
        [
            "path",
            {
                d: "M18 12L6 12",
                key: "1dxcgu",
            },
        ],
        [
            "path",
            {
                d: "M4 5L20 5",
                key: "1tsob7",
            },
        ],
        [
            "path",
            {
                d: "M8 19L16 19",
                key: "9atkxw",
            },
        ],
    ],
);
